import React, { useState } from "react";
import "../../css/Faculty.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const LEADERSHIP = [
  {
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&auto=format&fit=crop",
    role: "Principal",
    scope: "Overall School Leadership",
  },
  {
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&auto=format&fit=crop",
    role: "Vice Principal",
    scope: "Pre-Primary to Grade 5",
  },
  {
    image:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600&auto=format&fit=crop",
    role: "Vice Principal",
    scope: "Grade 6 to 12",
  },
  {
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&auto=format&fit=crop",
    role: "Academic Coordinator",
    scope: "Grade 1 & 2",
  },
  {
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&auto=format&fit=crop",
    role: "Academic Coordinator",
    scope: "Grade 3 to 5",
  },
  {
    image:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600&auto=format&fit=crop",
    role: "Academic Coordinator",
    scope: "Grade 6 to 8",
  },
  {
    image:
      "https://images.unsplash.com/photo-1504593811423-6dd665756598?w=600&auto=format&fit=crop",
    role: "Academic Coordinator",
    scope: "Grade 9 to 12",
  },
  {
    image:
      "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=600&auto=format&fit=crop",
    role: "ECA / CCA Coordinator",
    scope: "Co-Curricular Programs",
  },
];

const HIRING = [
  {
    icon: "🎯",
    title: "Domain Proficiency",
    desc: "We ensure every teacher is an expert in their subject, bringing real depth of experience into the classroom.",
  },
  {
    icon: "✅",
    title: "Selection Criteria",
    desc: "Our interview process is rigorous — evaluating interpersonal skills, past experience, and the ability to adapt and improvise.",
  },
  {
    icon: "📈",
    title: "Training",
    desc: "Teachers undergo structured training every year through a dedicated development program that helps them keep growing.",
  },
  {
    icon: "🤝",
    title: "Collaboration",
    desc: "We encourage knowledge-sharing across departments through regular training sessions and brainstorming on best practices.",
  },
];

const FAQ_ITEMS = [
  {
    q: "What makes Sahara Public School's faculty stand out?",
    a: "Our teachers are carefully selected for subject expertise, put through a rigorous interview process, and given ongoing training to keep improving their craft.",
  },
  {
    q: "How much training do teachers receive each year?",
    a: "Faculty members go through structured training programs annually, supported by a dedicated development team that identifies growth opportunities for each teacher.",
  },
  {
    q: "Does the school encourage collaboration among teachers?",
    a: "Yes, we regularly organise sessions where teachers share best practices and ideas, helping the whole faculty grow together.",
  },
];

export default function Faculty() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="faculty-page">
      {}
      <SchoolHero
        image="/images/ss.jpeg"
        title="OUR FACULTY"
        description="Meet our experienced teachers and academic leaders who inspire, guide, and nurture every student to achieve excellence."
      />
      <section className="faculty-hero">
        <h1>Our Faculty</h1>
        <p>
          Discover the experienced faculty at Sahara Public School, dedicated to
          enriching student life through quality education and holistic
          development.
        </p>
      </section>

      {}
      <section className="faculty-team-section">
        <div className="wrap">
          <h2>School Leadership</h2>
          <p>
            A dedicated leadership team overseeing academics and student
            experience across every grade.
          </p>
          <div className="faculty-grid">
            {LEADERSHIP.map((l, idx) => (
              <div className="faculty-card" key={idx}>
                <div className="faculty-avatar">
                  <img src={l.image} alt={l.role} />
                </div>
                <div className="faculty-role">{l.role}</div>
                <div className="faculty-scope">{l.scope}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="faculty-hiring-section">
        <div className="wrap">
          <h2>How We Hire Our Faculty</h2>
          <p>
            We look for a specific set of qualities to make sure every teacher
            can give students the education they deserve.
          </p>
          <div className="faculty-hiring-grid">
            {HIRING.map((h) => (
              <div className="faculty-hiring-card" key={h.title}>
                <div className="faculty-hiring-icon">{h.icon}</div>
                <h3>{h.title}</h3>
                <p>{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap faculty-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
